/**
 * Check if a given object implements the CreatePassTemplateResponse interface.
 */
export function instanceOfCreatePassTemplateResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
export function CreatePassTemplateResponseFromJSON(json) {
    return CreatePassTemplateResponseFromJSONTyped(json, false);
}
export function CreatePassTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function CreatePassTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
